/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_OwnershipInputs */

const cs_form_ownership = /** @type {(inputs: Form_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastnictví`)
};

const en_form_ownership = /** @type {(inputs: Form_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership`)
};

/**
* | output |
* | --- |
* | "Ownership" |
*
* @param {Form_OwnershipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_ownership = /** @type {((inputs?: Form_OwnershipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_OwnershipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_ownership(inputs)
	return cs_form_ownership(inputs)
});